@if (vm$ | async; as vm) {
  <div [formGroup]="form">
    <div class="filter-detail-editor__criteria-container">
      <div class="uw-field">
        <label for="criteria" class="uw-label">{{
          "common.criteria" | translate
        }}</label>
        <select id="criteria" formControlName="criteria" class="uw-select">
          <option [value]="DEFAULT_OPTION">
            {{ "common.select_criteria" | translate }}
          </option>
          @for (criteria of vm.criteria; track criteria) {
            <option
              [value]="criteria.criteriaValue"
              >
              {{ criteria.criteriaName }}
            </option>
          }
        </select>
      </div>
    </div>
    @if (form.value.criteria && form.value.criteria != DEFAULT_OPTION) {
      <div
        class="filter-detail-editor__condition-container"
        >
        <div class="uw-field">
          <label for="condition" class="uw-label">{{
            "common.condition" | translate
          }}</label>
          <select id="condition" formControlName="condition" class="uw-select">
            <option [value]="DEFAULT_OPTION">
              {{ "common.select" | translate }}
            </option>
            @for (condition of vm.conditions; track condition) {
              <option
                [value]="condition.value"
                >
                {{ condition.name }}
              </option>
            }
          </select>
        </div>
      </div>
    }
    @if (form.value.criteria && form.value.criteria != DEFAULT_OPTION) {
      <div
        class="filter-detail-editor__selections-container"
        >
        @if (vm.selections.length > 0) {
          <div class="uw-field">
            <label for="selection" class="uw-label">{{
              "common.selection" | translate
            }}</label>
            <select multiple id="selection" formControlName="selection" class="uw-select">
              <option [value]="DEFAULT_OPTION">
                {{ "common.select" | translate }}
              </option>
              @for (selection of vm.selections; track selection) {
                <option
                  [value]="selection.value"
                  >
                  {{ selection.name }}
                </option>
              }
            </select>
          </div>
        }
        @if (
          vm.selections.length == 0 && form.value.criteria == 'LastDonationDate'
          ) {
          <div
            class="uw-field uw-datepicker-input-field"
            >
            <label for="choose_date" class="uw-label">{{
              "common.choose_a_date" | translate
            }}</label>
            <div class="uw-datepicker-input">
              <input
                id="choose_date"
                type="text"
                [matDatepicker]="picker"
                formControlName="selection"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>
          }
          @if (
            vm.selections.length == 0 && form.value.criteria != 'LastDonationDate'
            ) {
            <div
              class="uw-field"
              >
              <label for="value" class="uw-label">{{
                "common.value" | translate
              }}</label>
              <input
                id="value"
                type="text"
                class="uw-input"
                formControlName="selection"
                />
              </div>
            }
          </div>
        }
        <div class="filter-detail-editor__button-container">
          @if (
            form.valid &&
            !form.pristine &&
            form.value.selection != DEFAULT_OPTION &&
            form.value.condition != DEFAULT_OPTION
            ) {
            <div
              tabindex="0"
              role="button"
              class="uw-pill"
              (keydown)="onAddKeydown($event)"
              (click)="handleCreateClick()"
              >
              {{ "common.create" | translate }}
            </div>
          }
        </div>
      </div>
    }
